import {
  CLASS_HIDDEN,
  CLASS_ACTIVE,
  CLASS_VISIBLE,
} from '../../tools/constants/classes';

const SELECTOR_CONTAINER = '[data-product-suitability]';
const SELECTOR_SKIN_SWATCH = '[data-skin-swatch]';
const SELECTOR_HAIR_SWATCH = '[data-hair-swatch]';
const SELECTOR_FAIL_SWATCH = '[data-not-suitable]';
const SELECTOR_STEP = '[data-product-suitability-step]';
const SELECTOR_FAIL = '[data-suitability-fail]';
const SELECTOR_PASS = '[data-suitability-pass]';
const SELECTOR_RESET = '[data-suitability-reset]';
const SELECTOR_PROGRESS_STEP = '[data-suitability-progress-step]';
const SELECTOR_ATC = '[data-suitability-atc]';
const SELECTOR_SWATCH_PROMPT = '[data-swatch-prompt]';
const SELECTOR_SWATCH = '[data-swatch-object]';
const SELECTOR_RESULTS = '[data-suitability-results]';
const SELECTOR_RESULT = '[data-suitability-result]';

const ATTR_PROGRESS_STEP = 'data-suitability-progress-step';
const ATTR_STEP_INDEX = 'data-product-suitability-step';
const ATTR_RESULT_SKIN_TONE = 'data-suitability-result-skin-tone';
const ATTR_RESULT_HAIR_COLOR = 'data-suitability-result-hair-color';

document.querySelectorAll(SELECTOR_CONTAINER).forEach((container) => {
  const skinSwatches =
    container.querySelectorAll<HTMLElement>(SELECTOR_SKIN_SWATCH);
  const hairSwatches =
    container.querySelectorAll<HTMLElement>(SELECTOR_HAIR_SWATCH);
  const failSwatches =
    container.querySelectorAll<HTMLElement>(SELECTOR_FAIL_SWATCH);
  const stepWrappers = container.querySelectorAll<HTMLElement>(SELECTOR_STEP);
  const resetButtons = container.querySelectorAll<HTMLElement>(SELECTOR_RESET);
  const progressSteps = container.querySelectorAll<HTMLElement>(
    SELECTOR_PROGRESS_STEP
  );
  const prompt = document.querySelector<HTMLElement>(SELECTOR_SWATCH_PROMPT);
  const atc = container.querySelector<HTMLElement>(SELECTOR_ATC);
  const swatches = document.querySelectorAll<HTMLElement>(SELECTOR_SWATCH);
  const resultsContainer = document.querySelector<HTMLElement>(SELECTOR_RESULTS);
  const results = document.querySelectorAll<HTMLElement>(SELECTOR_RESULT);

  // State
  const stepperState = {
    skinTone: null,
    hairColor: null
  }

  if (
    !skinSwatches ||
    !hairSwatches ||
    !failSwatches ||
    !stepWrappers ||
    !resetButtons ||
    !progressSteps ||
    !atc
  )
    return;

  /**
   * Highlights progress step of index passed in
   * Hides all slides and shows slide of index passed in
   * @param stepIndex - string containing index of step to show
   */
  const stepProgress = (stepIndex: string) => {
    progressSteps.forEach((step) => {
      const stepIdx = step.getAttribute(ATTR_PROGRESS_STEP);
      step.classList.remove(CLASS_ACTIVE);
      if (stepIdx === stepIndex) step.classList.add(CLASS_ACTIVE);
    });

    stepWrappers.forEach((wrapper) => {
      const stepIdx = wrapper.getAttribute(ATTR_STEP_INDEX);
      wrapper.classList.remove(CLASS_ACTIVE);
      if (stepIdx === stepIndex) wrapper.classList.add(CLASS_ACTIVE);
    });
  };

  // Move on to step 2
  skinSwatches.forEach((swatch) => {
    swatch.addEventListener('click', () => {
      stepperState.skinTone = swatch.dataset.skinSwatch
      stepProgress('2');
    });
  });

  // Move on to step 3. If suitable is false, show fail message
  hairSwatches.forEach((swatch) => {
    swatch.addEventListener('click', () => {
      stepperState.hairColor = swatch.dataset.hairSwatch
      stepProgress('3');
      finalStepImage();
    });
  });

  // Go back to step one, set suitable back to true
  resetButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      stepProgress('1');
    });
  });

  // If atc is clicked, scroll up to swatches and show select color prompt
  atc.addEventListener('click', function (evt) {
    evt.preventDefault();
    const anchorHref = atc.getAttribute('href');
    if (!anchorHref) return;
    const anchor = document.querySelector(anchorHref);
    if (!anchor) return;

    anchor.scrollIntoView({
      behavior: 'smooth',
    });

    if (prompt) {
      prompt.classList.add(CLASS_VISIBLE);
      swatches.forEach((swatch) => {
        swatch.addEventListener('click', () => {
          prompt.classList.remove(CLASS_VISIBLE);
        });
      });
    }
  });

  function finalStepImage() {
    if (!resultsContainer || !results) { return }

    const matchingResult = Array.from(results).find(result =>
      result.getAttribute(ATTR_RESULT_SKIN_TONE) === stepperState.skinTone &&
      result.getAttribute(ATTR_RESULT_HAIR_COLOR) === stepperState.hairColor
    );

    results.forEach((result) => result.classList.remove('active'));

    if (matchingResult) {
      matchingResult.classList.add('active');
      resultsContainer.classList.add('active');
    } else {
      resultsContainer.classList.remove('active');
    }
  }
});
